import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { BibleAura } from '../components/BibleAura';
import { BibleReveal } from '../components/BibleReveal';
import { BibleCover } from '../components/BibleCover';
import { BibleVsl } from '../components/BibleVsl';
import { BibleProducts } from '../components/BibleProducts';
import { BibleTestimonials } from '../components/BibleTestimonials';
import { BibleFaq } from '../components/BibleFaq';
import { BibleStickyBar } from '../components/BibleStickyBar';
import { BIBLE_PRIMARY_CTA_ID, useBibleCheckout } from '../hooks/useBibleCheckout';
import { bibleConfig } from '../data/bibleConfig';
import { safeUrl } from '../utils/safeUrl';
import { scheduleMetaPixel } from '../utils/metaPixel';
export function BiblePage() {
  const {
    purchaseHref,
    secondaryHref,
    noticeVisible,
    handlePurchaseClick,
    handleSecondaryClick
  } = useBibleCheckout();
  useEffect(() => scheduleMetaPixel(), []);
  const supportUrl = safeUrl(bibleConfig.supportUrl, true);
  const privacyUrl = safeUrl(bibleConfig.privacyUrl);
  const termsUrl = safeUrl(bibleConfig.termsUrl);
  return <div className="bible-body relative min-h-screen w-full overflow-x-hidden bg-[#0b0b0e] text-[#f7f2e8]" data-id="element-278" data-mp="2hfxfraunxc7x">
      <BibleAura data-id="element-279" data-mp="2v727lqrsh07p" />

      <a href="#contenido" className="absolute -top-24 left-2 z-50 bg-[#0b0b0e] p-2.5 focus:top-2.5" data-id="element-280" data-mp="2v9oerparpdpe">
        Saltar al contenido
      </a>

      <div className="relative z-10 border-b border-[#2c2a30] px-5 py-3 text-center text-[12px] tracking-[0.08em] text-[#e9c769]" data-id="element-281" data-mp="23hgyipz6c3bj">
        GUÍAS DIGITALES + ACCESO A SKOOL · PAGO ÚNICO DE $11.99
      </div>

      <div className="relative z-10 mx-auto w-[calc(100%-36px)] max-w-[1120px] md:w-[calc(100%-48px)]" data-id="element-282" data-mp="2cix84vi601ep">
        <header className="flex items-center justify-between gap-5 py-5 md:py-[26px]" data-id="element-283" data-mp="27gy37h6s0wfn">
          <span className="text-[10px] font-extrabold leading-[1.3] tracking-[0.15em] md:text-[12px]" data-id="element-284" data-mp="3nuy0sli5g9zq">
            START LAUNCHING
            <br data-id="element-285" data-mp="3izsfnowkmzcp" />
            CREATIVES
          </span>
          <nav aria-label="Navegación principal" className="flex gap-3.5 text-[12px] text-[#beb9b0] md:gap-6 md:text-[13px]" data-id="element-286" data-mp="2gj8ebnjwlt52">
            <a href="#materiales" className="hidden no-underline transition-colors hover:text-[#e9c769] min-[381px]:inline" data-id="element-287" data-mp="2pky6wwpiuy4f">
              Qué incluye
            </a>
            <a href="#preguntas" className="no-underline transition-colors hover:text-[#e9c769]" data-id="element-288" data-mp="1xu246ox6e9uv">
              Preguntas
            </a>
          </nav>
        </header>
      </div>

      <main id="contenido" className="relative z-10" data-id="element-289" data-mp="26t5m3pklwj7s">
        {/* HERO */}
        <section className="bg-[radial-gradient(ellipse_at_80%_30%,#42301940,transparent_62%)] pb-12 pt-6 md:pb-[74px] md:pt-[42px]" data-id="element-290" data-mp="2blgocz2tkh3i">
          <div className="mx-auto w-[calc(100%-36px)] max-w-[1120px] md:w-[calc(100%-48px)]" data-id="element-291" data-mp="1e4rlr361pat2">
            <div className="grid items-center gap-7 md:grid-cols-[1.4fr_0.8fr] md:gap-[70px]" style={{
            perspective: '1400px'
          }} data-id="element-292" data-mp="1j3bblenrf6qp">
              <div data-id="element-293" data-mp="16lii7qk806bx">
                <motion.p initial={{
                opacity: 0,
                y: 14
              }} animate={{
                opacity: 1,
                y: 0
              }} transition={{
                duration: 0.5
              }} className="mb-5 text-[11px] font-bold uppercase tracking-[0.2em] text-[#e9c769]" data-id="element-294" data-mp="16n1tt3uxlt7d">
                  The Visual Disruption Bible 2.0
                </motion.p>
                <motion.h1 initial={{
                opacity: 0,
                y: 26
              }} animate={{
                opacity: 1,
                y: 0
              }} transition={{
                duration: 0.8,
                delay: 0.08,
                ease: [0.22, 1, 0.36, 1]
              }} className="bible-serif mb-6 text-[clamp(34px,5.1vw,65px)]" data-id="element-295" data-mp="nvsj4r9fcye7">
                  La idea está en tu cabeza.
                  <br data-id="element-296" data-mp="9uy9k5an4rdy" />
                  <em className="bible-em" data-id="element-297" data-mp="9xkleh4kdt1z">
                    Aprende a convertirla en instrucciones para la IA.
                  </em>
                </motion.h1>
                <motion.p initial={{
                opacity: 0,
                y: 20
              }} animate={{
                opacity: 1,
                y: 0
              }} transition={{
                duration: 0.7,
                delay: 0.18
              }} className="max-w-[670px] text-[17px] text-[#beb9b0] md:text-[19px]" data-id="element-298" data-mp="24zftz5keljvv">
                  Dale dirección a tus imágenes y videos: define la escena, la
                  luz, la cámara y la secuencia con guías escritas y ejemplos que
                  puedes adaptar a tu marca.
                </motion.p>
                <motion.p initial={{
                opacity: 0,
                y: 18
              }} animate={{
                opacity: 1,
                y: 0
              }} transition={{
                duration: 0.7,
                delay: 0.26
              }} className="mt-4 text-[#beb9b0]" data-id="element-299" data-mp="1q7nf0uoiu7uo">
                  Para creadores y emprendedores que ya probaron la IA y quieren
                  dejar de improvisar cada prompt.
                </motion.p>
                <div className="mt-6 flex flex-wrap gap-2.5" data-id="element-300" data-mp="3lrb08rfio1p8">
                  {['6 PDF descargables', 'Acceso a Skool', 'Garantía de 7 días'].map((chip, index) => <motion.span key={chip} initial={{
                  opacity: 0,
                  y: 14
                }} animate={{
                  opacity: 1,
                  y: 0
                }} transition={{
                  duration: 0.5,
                  delay: 0.34 + index * 0.08
                }} className="rounded-full border border-[#2c2a30] px-3 py-1.5 text-[12px] transition-colors hover:border-[#7b663b]" data-id="element-301" data-mp="3ukekbiko3csu" data-mpi={index}>
                      {chip}
                    </motion.span>)}
                </div>
              </div>

              <BibleCover asset="bible" lines={['VISUAL', 'DISRUPTION', 'BIBLE 2.0']} note="GUÍA DIGITAL · EDICIÓN EN PDF" eager className="bible-float-3d mx-auto mt-2.5 w-[min(260px,70%)] shadow-[0_24px_80px_#0008] md:mt-0 md:w-full" data-id="element-302" data-mp="d9n8jpzpucha" />
            </div>

            <BibleReveal className="mx-auto mt-10 max-w-[880px] md:mt-[60px]" data-id="element-303" data-mp="n2cs5vs0givm">
              <p className="mb-4 text-[11px] font-bold uppercase tracking-[0.2em] text-[#e9c769]" data-id="element-304" data-mp="rzv1vodur24o">
                Mira cómo se conecta una idea con un prompt
              </p>
              <BibleVsl data-id="element-305" data-mp="1112pnciqskki" />
              <p className="mt-3.5 text-center text-[12px] text-[#beb9b0]" data-id="element-306" data-mp="111m58mkx6wvd">
                Ejemplos de creación con IA. Los resultados dependen de la
                herramienta, las referencias y los ajustes realizados.
              </p>
            </BibleReveal>
          </div>
        </section>

        {/* 01 */}
        <section className="border-t border-[#2c2a30] py-[50px] md:py-[76px]" data-id="element-307" data-mp="1foxiqu0nwqy4">
          <div className="mx-auto grid w-[calc(100%-36px)] max-w-[1120px] items-start gap-7 md:w-[calc(100%-48px)] md:grid-cols-[1.2fr_1fr] md:gap-[65px]" data-id="element-308" data-mp="1kplgrznb681u">
            <BibleReveal data-id="element-309" data-mp="1ooknnpsloevx">
              <p className="mb-5 text-[11px] font-bold uppercase tracking-[0.2em] text-[#e9c769]" data-id="element-310" data-mp="398g074oobhtw">
                01 / El punto de partida
              </p>
              <h2 className="bible-serif mb-6 max-w-[800px] text-[clamp(28px,4vw,47px)]" data-id="element-311" data-mp="355t0yipoaumo">
                Sabes qué quieres ver.
                <br data-id="element-312" data-mp="2v8wsgczry8i4" />
                Pero el resultado se siente{' '}
                <em className="bible-em" data-id="element-313" data-mp="2varclp381wl5">lejos de tu idea.</em>
              </h2>
              <p className="text-[#beb9b0]" data-id="element-314" data-mp="3svdpdh4lik3c">
                Imaginas un producto flotando, una cámara atravesando una escena
                o una imagen con luz de cine. Escribes el prompt, generas… y algo
                no encaja.
              </p>
              <p className="mt-4 text-[#beb9b0]" data-id="element-315" data-mp="3e82b37h14lzj">
                Cambias palabras. Añades “cinematográfico”. Copias otra
                instrucción. Aun así, cuesta saber qué ajustar y por qué.
              </p>
            </BibleReveal>
            <BibleReveal delay={0.12} data-id="element-316" data-mp="aqae1eo1dbuh">
              <aside className="bible-tilt rounded-r-lg border-l-2 border-[#e9c769] bg-[#141419] px-[30px] py-6 font-[Georgia,serif] text-[22px] italic leading-[1.5] md:text-[25px]" data-id="element-317" data-mp="ap91t6vaajb6">
                Una idea puede ser muy clara en tu cabeza y seguir siendo
                demasiado vaga en un prompt.
              </aside>
            </BibleReveal>
          </div>
        </section>

        {/* 02 */}
        <section className="border-t border-[#2c2a30] py-[50px] md:py-[76px]" data-id="element-318" data-mp="3a7frsk6jmh1l">
          <div className="mx-auto grid w-[calc(100%-36px)] max-w-[1120px] items-start gap-7 md:w-[calc(100%-48px)] md:grid-cols-[1.2fr_1fr] md:gap-[65px]" data-id="element-319" data-mp="1urzlid0o3f7">
            <BibleReveal data-id="element-320" data-mp="3ozhmlptrajur">
              <p className="mb-5 text-[11px] font-bold uppercase tracking-[0.2em] text-[#e9c769]" data-id="element-321" data-mp="3oy6jztc1ri58">
                02 / La frustración
              </p>
              <h2 className="bible-serif mb-6 max-w-[800px] text-[clamp(28px,4vw,47px)]" data-id="element-322" data-mp="2djt00zkezmuh">
                Cada intento debería darte algo más que{' '}
                <em className="bible-em" data-id="element-323" data-mp="2ik77afe6ysrg">otro resultado distinto.</em>
              </h2>
              <p className="text-[#beb9b0]" data-id="element-324" data-mp="2a0asc52z3ooq">
                Si cambias todo a la vez, resulta difícil identificar qué mejora
                la imagen: el encuadre, la iluminación, la referencia o la
                acción.
              </p>
              <p className="mt-4 text-[#beb9b0]" data-id="element-325" data-mp="2f0oyfhl0kok4">
                Y cuando encuentras un prompt atractivo, todavía queda la parte
                importante: adaptarlo a tu producto, a tu mensaje y a la historia
                que quieres contar.
              </p>
            </BibleReveal>
            <BibleReveal delay={0.12} data-id="element-326" data-mp="1ma6njue1tiw5">
              <aside className="bible-tilt rounded-r-lg border-l-2 border-[#e995b3] bg-[#141419] px-[30px] py-6 font-[Georgia,serif] text-[22px] italic leading-[1.5] md:text-[25px]" data-id="element-327" data-mp="211746moy8j3d">
                El siguiente paso es aprender qué decisiones estás tomando cuando
                escribes una instrucción.
              </aside>
            </BibleReveal>
          </div>
        </section>

        {/* 03 */}
        <section className="border-t border-[#2c2a30] py-[50px] md:py-[76px]" data-id="element-328" data-mp="1qt8zvqz6sc6j">
          <div className="mx-auto w-[calc(100%-36px)] max-w-[1120px] md:w-[calc(100%-48px)]" data-id="element-329" data-mp="1luo0ftrrdwj5">
            <BibleReveal data-id="element-330" data-mp="1gvunq3kaq9k1">
              <p className="mb-5 text-[11px] font-bold uppercase tracking-[0.2em] text-[#e9c769]" data-id="element-331" data-mp="1gv31vkgi3q6y">
                03 / El método
              </p>
              <h2 className="bible-serif mb-6 max-w-[800px] text-[clamp(28px,4vw,47px)]" data-id="element-332" data-mp="1bzduiuy8p503">
                Empieza a pensar tu visual{' '}
                <em className="bible-em" data-id="element-333" data-mp="134fyhezspc4j">antes de generarlo.</em>
              </h2>
              <p className="max-w-[670px] text-[17px] text-[#beb9b0] md:text-[19px]" data-id="element-334" data-mp="y53f5484un6p">
                El material combina ejemplos de prompts con principios de
                composición y narrativa. Una base para elegir con intención,
                probar y ajustar.
              </p>
            </BibleReveal>

            <div className="mt-8 grid gap-3 md:grid-cols-3 md:gap-[18px]" style={{
            perspective: '1200px'
          }} data-id="element-335" data-mp="k5lm2cnt0nrj">
              {[{
              step: '01 · DEFINE',
              title: 'La escena y su intención',
              text: 'Decide qué debe destacar, qué quieres comunicar y qué elemento hará especial la imagen.'
            }, {
              step: '02 · ESTRUCTURA',
              title: 'Las instrucciones',
              text: 'Especifica sujeto, entorno, luz y cámara. Para video, organiza la acción en una secuencia.'
            }, {
              step: '03 · ADAPTA',
              title: 'El ejemplo a tu idea',
              text: 'Usa las referencias del material, cambia las variables y evalúa qué necesita el siguiente intento.'
            }].map((item, index) => <motion.article key={item.step} initial={{
              opacity: 0,
              y: 28,
              rotateX: 8
            }} whileInView={{
              opacity: 1,
              y: 0,
              rotateX: 0
            }} viewport={{
              once: true,
              amount: 0.3
            }} transition={{
              duration: 0.6,
              delay: index * 0.09,
              ease: [0.22, 1, 0.36, 1]
            }} className="bible-tilt rounded-xl border border-[#2c2a30] bg-[#141419] p-6" data-id="element-336" data-mp="1tcm61n6tknh3" data-mpi={index}>
                  <b className="mb-[18px] block text-[12px] tracking-[0.1em] text-[#e9c769]" data-id="element-337" data-mp="17dzr8mrlxz96">
                    {item.step}
                  </b>
                  <h3 className="bible-serif-tight text-[20px] leading-[1.35]" data-id="element-338" data-mp="13e8r3sg6y6rz">
                    {item.title}
                  </h3>
                  <p className="mt-2 text-[15px] text-[#beb9b0]" data-id="element-339" data-mp="1cdcbczr3gs82">{item.text}</p>
                </motion.article>)}
            </div>

            <p className="mt-6 text-[13px] text-[#beb9b0]" data-id="element-340" data-mp="2sqavjsxzb779">
              El proceso requiere práctica. Las herramientas de generación y
              edición se utilizan por separado.
            </p>
          </div>
        </section>

        {/* 04 */}
        <section id="materiales" className="border-t border-[#2c2a30] py-[50px] md:py-[76px]" data-id="element-341" data-mp="ejthd8i6w0ei">
          <div className="mx-auto w-[calc(100%-36px)] max-w-[1120px] md:w-[calc(100%-48px)]" data-id="element-342" data-mp="ktr5wf13dg8">
            <BibleReveal data-id="element-343" data-mp="5imwkn8ic3fg">
              <p className="mb-5 text-[11px] font-bold uppercase tracking-[0.2em] text-[#e9c769]" data-id="element-344" data-mp="5jy1iqdovh85">
                04 / Lo que recibes
              </p>
              <h2 className="bible-serif mb-6 max-w-[800px] text-[clamp(28px,4vw,47px)]" data-id="element-345" data-mp="xab2os0oztpu">
                Una biblioteca para{' '}
                <em className="bible-em" data-id="element-346" data-mp="jhuz9q3vptoe">dar dirección a tu creatividad.</em>
              </h2>
              <p className="max-w-[670px] text-[17px] text-[#beb9b0] md:text-[19px]" data-id="element-347" data-mp="oh7nae6hl6sk">
                Recibes cinco documentos de contenido y una guía de acceso a la
                comunidad: seis PDF en total, más acceso a Skool.
              </p>
            </BibleReveal>

            <BibleProducts data-id="element-348" data-mp="3ohmy9bciqnzb" />

            <p className="mt-6 text-[13px] text-[#beb9b0]" data-id="element-349" data-mp="3oixxcxv0r7k3">
              Material digital. No se envían libros físicos. Las suscripciones a
              herramientas de IA no están incluidas. Para trabajos comerciales,
              revisa también las condiciones de la herramienta y de los recursos
              que utilices.
            </p>
          </div>
        </section>

        {/* SOCIAL PROOF */}
        <section id="testimonios" className="border-t border-[#2c2a30] py-[50px] md:py-[76px]" data-id="element-350" data-mp="b1oywztt45ov">
          <div className="mx-auto w-[calc(100%-36px)] max-w-[1120px] md:w-[calc(100%-48px)]" data-id="element-351" data-mp="73hrivl8ggqc">
            <BibleReveal data-id="element-352" data-mp="28txyibdgw4w">
              <p className="mb-5 text-[11px] font-bold uppercase tracking-[0.2em] text-[#e9c769]" data-id="element-353" data-mp="3tgzh7l09rawm">
                Lo que dicen quienes ya lo están usando
              </p>
              <h2 className="bible-serif mb-8 max-w-[800px] text-[clamp(28px,4vw,47px)]" data-id="element-354" data-mp="ut2cfk0y5o29">
                Creadores que dejaron de{' '}
                <em className="bible-em" data-id="element-355" data-mp="xbnns7mt45nl">improvisar cada prompt.</em>
              </h2>
            </BibleReveal>

            <BibleReveal delay={0.1} data-id="element-356" data-mp="129p3qjoxrouu">
              <BibleTestimonials data-id="element-357" data-mp="12aqs1puyq7ui" />
            </BibleReveal>

            <p className="mt-5 text-[13px] text-[#beb9b0]" data-id="element-358" data-mp="179br3lyhalhd">
              Comentarios compartidos por miembros de la comunidad. Los
              resultados dependen de la práctica, la herramienta y los ajustes de
              cada persona.
            </p>
          </div>
        </section>

        {/* 05 */}
        <section id="oferta" className="scroll-mt-7 border-t border-[#2c2a30] py-[50px] md:py-[76px]" data-id="element-359" data-mp="1l8b601w6vm0c">
          <div className="mx-auto grid w-[calc(100%-36px)] max-w-[1120px] items-center gap-7 md:w-[calc(100%-48px)] md:grid-cols-2 md:gap-[45px]" data-id="element-360" data-mp="1q0uqzjx7hjf6">
            <BibleReveal data-id="element-361" data-mp="1z19empxn7alu">
              <p className="mb-5 text-[11px] font-bold uppercase tracking-[0.2em] text-[#e9c769]" data-id="element-362" data-mp="1z22dl4qd0vtf">
                05 / Tu acceso
              </p>
              <h2 className="bible-serif mb-6 text-[clamp(28px,4vw,47px)]" data-id="element-363" data-mp="3xkx2fjpwngs">
                Dale una estructura
                <br data-id="element-364" data-mp="3w1ncroe0f56u" />a tu <em className="bible-em" data-id="element-365" data-mp="3w26mwixf4pab">próxima idea.</em>
              </h2>
              <ul className="my-6 list-none p-0" data-id="element-366" data-mp="dnea7kzidan5">
                {['Los seis PDF descritos arriba.', 'Ejemplos para adaptar a imágenes y videos.', 'Principios de composición y narrativa visual.', 'Acceso a la comunidad en Skool.', 'Siete días para revisar el material con garantía.'].map((item, index) => <motion.li key={item} initial={{
                opacity: 0,
                x: -16
              }} whileInView={{
                opacity: 1,
                x: 0
              }} viewport={{
                once: true,
                amount: 0.6
              }} transition={{
                duration: 0.45,
                delay: index * 0.06
              }} className="flex gap-3.5 border-b border-[#2c2a30] py-3.5 text-[15px]" data-id="element-367" data-mp="wms2lyhladbj" data-mpi={index}>
                    <span aria-hidden="true" className="text-[#e9c769]" data-id="element-368" data-mp="18xj4dre1z49y">
                      ✓
                    </span>
                    {item}
                  </motion.li>)}
              </ul>
            </BibleReveal>

            <BibleReveal delay={0.12} data-id="element-369" data-mp="1023grs3w5lct">
              <div className="bible-tilt rounded-2xl border border-[#7b663b] bg-[linear-gradient(150deg,#30271688,#141419)] px-5 py-7 text-center md:p-[38px]" data-id="element-370" data-mp="1459h6j4boibd">
                <p className="text-[11px] font-bold uppercase tracking-[0.2em] text-[#e9c769]" data-id="element-371" data-mp="q833h2ygh9t0">
                  Visual Disruption Bible 2.0 + complementos
                </p>
                <motion.p initial={{
                opacity: 0,
                scale: 0.92
              }} whileInView={{
                opacity: 1,
                scale: 1
              }} viewport={{
                once: true,
                amount: 0.6
              }} transition={{
                duration: 0.6,
                ease: [0.22, 1, 0.36, 1]
              }} className="my-4 font-[Georgia,serif] text-[76px] leading-none tracking-[-0.05em] text-[#e9c769] [text-shadow:0_0_36px_rgba(233,199,105,0.35)]" data-id="element-372" data-mp="h6wk8m4f9kw2">
                  $11.99
                </motion.p>
                <p data-id="element-373" data-mp="yd06apsewpkh">Un solo pago por el paquete y el acceso a Skool.</p>
                <a id={BIBLE_PRIMARY_CTA_ID} href={purchaseHref} onClick={handlePurchaseClick} className="bible-cta mt-4 w-full scroll-mt-[30vh]" data-id="element-374" data-mp="tl03mpkyjik7">
                  Quiero acceder por $11.99 →
                </a>
                <p className="mt-3.5 text-[13px] text-[#beb9b0]" data-id="element-375" data-mp="fkyyuz1knqzg">
                  Entrega digital · Garantía de 7 días
                </p>
                <p className="mt-3.5 text-[13px] text-[#beb9b0]" data-id="element-376" data-mp="ap06l0d4hotr">
                  Herramientas de IA y edición por separado. Pueden requerir
                  pagos o créditos adicionales.
                </p>
                <p hidden={!noticeVisible} role="status" className="mt-3 text-[13px] text-[#e995b3]" data-id="element-377" data-mp="24ykl4uknzaim">
                  El enlace de compra aún no está disponible.
                </p>
              </div>
            </BibleReveal>
          </div>
        </section>

        {/* 06 */}
        <section className="border-t border-[#2c2a30] py-[50px] md:py-[76px]" data-id="element-378" data-mp="2hc7m0f4pow72">
          <div className="mx-auto w-[calc(100%-36px)] max-w-[1120px] md:w-[calc(100%-48px)]" data-id="element-379" data-mp="2masn0grsfjwk">
            <BibleReveal data-id="element-380" data-mp="1pki6aomtcm6x">
              <p className="mb-5 text-[11px] font-bold uppercase tracking-[0.2em] text-[#e9c769]" data-id="element-381" data-mp="1plbgy0ow7vuc">
                06 / Compra con tranquilidad
              </p>
              <div className="grid gap-6 rounded-xl border border-[#2c2a30] bg-[#141419] p-6 md:grid-cols-[70px_1fr] md:gap-[25px] md:p-[35px]" data-id="element-382" data-mp="1yky7tsjzxj95">
                <div aria-hidden="true" className="grid h-[65px] w-[65px] place-items-center rounded-full border border-[#e9c769] font-[Georgia,serif] text-[30px] text-[#e9c769] shadow-[0_0_28px_rgba(233,199,105,0.25)]" data-id="element-383" data-mp="23lcizjgw99be">
                  7
                </div>
                <div data-id="element-384" data-mp="um9jqu5xsplw">
                  <h2 className="bible-serif mb-4 text-[28px] md:text-[34px]" data-id="element-385" data-mp="zngqcpwcfiqz">
                    Tómate siete días para{' '}
                    <em className="bible-em" data-id="element-386" data-mp="14dx3sa05z4dc">revisarlo.</em>
                  </h2>
                  <p className="text-[#beb9b0]" data-id="element-387" data-mp="19d0arzzpfkny">
                    Si el material no es para ti, solicita la devolución dentro
                    de los siete días posteriores a la compra. Te devolvemos lo
                    pagado por el producto, sin preguntas.
                  </p>
                  <p className="mt-3.5 text-[14px] text-[#beb9b0]" data-id="element-388" data-mp="lnp7obuvte6n">
                    Solicítala a través del canal de soporte indicado en tu
                    confirmación de compra.
                  </p>
                </div>
              </div>
            </BibleReveal>
          </div>
        </section>

        {/* 07 */}
        <section id="preguntas" className="border-t border-[#2c2a30] py-[50px] md:py-[76px]" data-id="element-389" data-mp="213o9z6htifyz">
          <div className="mx-auto w-[calc(100%-36px)] max-w-[860px] md:w-[calc(100%-48px)]" data-id="element-390" data-mp="3llytj0786817">
            <BibleReveal data-id="element-391" data-mp="3hm6fi7z2b9og">
              <p className="mb-5 text-[11px] font-bold uppercase tracking-[0.2em] text-[#e9c769]" data-id="element-392" data-mp="3hmzrpogsirdz">
                07 / Preguntas frecuentes
              </p>
              <h2 className="bible-serif mb-6 text-[clamp(28px,4vw,47px)]" data-id="element-393" data-mp="37u0s7bjr9gfl">
                Antes de <em className="bible-em" data-id="element-394" data-mp="32w90ahj41ube">empezar.</em>
              </h2>
              <BibleFaq data-id="element-395" data-mp="2xww1qzivmysz" />
            </BibleReveal>
          </div>
        </section>

        {/* 08 */}
        <section className="border-t border-[#2c2a30] py-[50px] md:py-[76px]" data-id="element-396" data-mp="2tvavvy4rfksa">
          <div className="mx-auto w-[calc(100%-36px)] max-w-[800px] text-center md:w-[calc(100%-48px)]" data-id="element-397" data-mp="2txeymcqxadqz">
            <BibleReveal data-id="element-398" data-mp="2oykg7bwvar7e">
              <p className="mb-5 text-[11px] font-bold uppercase tracking-[0.2em] text-[#e9c769]" data-id="element-399" data-mp="s4ha2t46i7bu">
                08 / Tu próxima creación
              </p>
              <h2 className="bible-serif mx-auto mb-6 text-[clamp(28px,4vw,47px)]" data-id="element-400" data-mp="n2rvj3hqzbj0">
                La próxima vez que tengas una idea,
                <br data-id="element-401" data-mp="1b0pujgk043cb" />
                <em className="bible-em" data-id="element-402" data-mp="1b17ykzcwnlus">dale una dirección.</em>
              </h2>
              <p className="mx-auto max-w-[670px] text-[17px] text-[#beb9b0] md:text-[19px]" data-id="element-403" data-mp="x9b9732mfq23">
                Abre el material. Elige una escena. Adapta un ejemplo. Empieza a
                tomar decisiones sobre lo que quieres crear y lo que vas a
                pedirle a la IA.
              </p>
              <a href={secondaryHref} onClick={handleSecondaryClick} className="bible-cta mt-4" data-id="element-404" data-mp="1tzk6khs2ypos">
                Quiero empezar — acceso por $11.99 →
              </a>
              <p className="mt-[17px] text-[13px] text-[#beb9b0]" data-id="element-405" data-mp="1kwsuqgvalrwm">
                Seis PDF + acceso a Skool · Un solo pago · Garantía de 7 días
              </p>
              <p hidden={!noticeVisible} role="status" className="mt-3 text-[13px] text-[#e995b3]" data-id="element-406" data-mp="9jqfpq8udaek">
                El enlace de compra aún no está disponible.
              </p>
            </BibleReveal>
          </div>
        </section>
      </main>

      <footer className="relative z-10 border-t border-[#2c2a30] px-0 pb-[125px] pt-9 text-[12px] text-[#beb9b0] md:pb-[130px]" data-id="element-407" data-mp="b0me489fyc47">
        <div className="mx-auto flex w-[calc(100%-36px)] max-w-[1120px] flex-wrap justify-between gap-5 md:w-[calc(100%-48px)]" data-id="element-408" data-mp="61t10gy2gn4k">
          <span data-id="element-409" data-mp="3eeqjz8kgpbxp">© {new Date().getFullYear()} Start Launching Creatives</span>
          <div className="flex gap-5" data-id="element-410" data-mp="3ahc8tbd80u32">
            {supportUrl ? <a id="support-link" href={supportUrl} data-id="element-411" data-mp="3o7xs316l761h">
                Contacto
              </a> : null}
            {privacyUrl ? <a id="privacy-link" href={privacyUrl} data-id="element-412" data-mp="3jecsx5t9c60p">
                Privacidad
              </a> : null}
            {termsUrl ? <a id="terms-link" href={termsUrl} data-id="element-413" data-mp="2qqh1afijp4as">
                Términos
              </a> : null}
          </div>
          <span data-id="element-414" data-mp="34g28ho5gjwoq">
            Este sitio no está afiliado a Meta ni a las plataformas de IA
            mencionadas.
          </span>
        </div>
      </footer>

      <BibleStickyBar href={secondaryHref} onClick={handleSecondaryClick} data-id="element-415" data-mp="3ec56qix6vb6e" />
    </div>;
}